export const storeConverter = (storeId) => {
  switch (storeId) {
    case "1":
      return "meeting area";
    case "2":
      return "cinema";
    case "3":
      return "valeries";
    case "4":
      return "food court";
    case "5":
      return "tunes";
    case "6":
      return "damicos";
    case "7":
      return "smileys arcade";
    case "8":
      return "book shelf";
    case "9":
      return "radiance salon";
    default:
      return "home";
  }
};

export const activityConverter = (activity) => {
  switch (activity) {
    case "book":
      return ":read books";
    case "game":
      return ":play games";
    case "quiz":
      return ":take quiz";
    default:
      return "";
  }
};

export const pageNameConverter = (pathArray) => {
  if (pathArray.length > 3) {
    return `ag:vm:${storeConverter(
      pathArray[pathArray.length - 3]
    )}${activityConverter(pathArray[pathArray.length - 2])}`;
  }
  return `ag:vm:${storeConverter(
    pathArray[pathArray.length - 1]
  )}`
};

export const handleUpdatePageInfoData = (data) => {
  window.digitalData.pageInfo = data;
};

export const handleEventInfoData = (info) => {
  window.digitalData.event = {
    event_name: info.storeName,
    event_type: 'click',
    item_clicked: info.page_name,
    item_subcategory: '',
    location_name: info.location_name

  }
}
